import { render, staticRenderFns } from "./EditChartDataTable.vue?vue&type=template&id=0d95ead6"
import script from "./EditChartDataTable.vue?vue&type=script&lang=js"
export * from "./EditChartDataTable.vue?vue&type=script&lang=js"
import style0 from "./EditChartDataTable.vue?vue&type=style&index=0&id=0d95ead6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports